import React from 'react';
import { Badge } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { ImportRowStatusColors, ImportStatusColors, ImportStatusLabels } from '../../../constants/importStatuses';

import { humanize } from './util';

const ImportStatusBadge = ({ status, kind = 'import', ...props }) => {
  const colors = kind === 'row' ? ImportRowStatusColors : ImportStatusColors;
  const label = kind === 'row' ? humanize(status) : (ImportStatusLabels[status] ?? humanize(status));

  return (
    <Badge colorScheme={colors[status] ?? 'gray'} data-testid={`${kind}-status-${status}`} px={2} py={1} textTransform="capitalize" {...props}>
      {label}
    </Badge>
  );
};

ImportStatusBadge.propTypes = {
  status: PropTypes.string,
  kind: PropTypes.oneOf(['import', 'row'])
};

export default ImportStatusBadge;
